import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../../components/admin/Sidebar';
import '../../styles/admin/admin-layout.css';
import '../../styles/admin/admin-components.css';

export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="app">
      {/* Mobile top bar */}
      <div className="mob-bar">
        <div className="mob-logo">
          <div className="sb-mark">
            <svg viewBox="0 0 14 14" fill="none"><polygon points="7,1 13,13 1,13" fill="#0C0B09" /></svg>
          </div>
          <div className="sb-brand">AI <span>Foundry</span></div>
        </div>
        <button className={`hamburger${sidebarOpen ? ' open' : ''}`} onClick={() => setSidebarOpen(o => !o)}>
          <span /><span /><span />
        </button>
      </div>

      {/* Sidebar overlay */}
      <div className={`sb-overlay${sidebarOpen ? ' open' : ''}`} onClick={() => setSidebarOpen(false)} />

      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="main anim-fade">
        <Outlet />
      </div>
    </div>
  );
}
